import React from 'react';
import cx from 'classnames';
import MUITextField, {
  TextFieldProps as MUITextFieldProps,
} from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  filledInput: {
    backgroundColor: theme.palette.grey[50],
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
    },
    '&:focus': {
      backgroundColor: theme.palette.grey[50],
    },
    '&:active': {
      backgroundColor: theme.palette.grey[50],
    },
    '&:visited': {
      backgroundColor: theme.palette.grey[50],
    },
    '&:focus-within': {
      backgroundColor: theme.palette.grey[50],
    },
  },
}));

const TextField: React.FC<MUITextFieldProps> = ({
  variant,
  InputProps = {},
  ...rest
}) => {
  const classes = useStyles();

  return (
    <MUITextField
      variant={variant}
      InputProps={{
        ...InputProps,
        classes: {
          ...InputProps.classes,
          root: cx(
            {
              [classes.filledInput]: variant === 'filled',
            },
            InputProps.classes?.root,
          ),
        },
      }}
      {...rest}
    />
  );
};

export default TextField;

export type TextFieldProps = MUITextFieldProps;
